// ARGE Cosmetics online store — catalogue data.
// ONLY the group's own brands are listed: WELLMAX, MAXWELL and DOPAMINE (coming soon).
// Product imagery lifted from the group's sales portal (uzayparfumeri.com CDN).
// Prices: Turkish RRP converted to GBP (£1 = ₺65) + 10% markup, rounded up to .99.

const W = 'https://static.ticimax.cloud/cdn-cgi/image/width=600,quality=85,format=webp/76346/Uploads/UrunResimleri/buyuk';
const M = 'https://static.ticimax.cloud/cdn-cgi/image/width=600,quality=85,format=webp/76346/uploads/urunresimleri/buyuk';
const D = 'https://www.dopamine.org.tr/assets';

export const SHOP_CATEGORIES = [
  { id: 'all', label: 'All Products' },
  { id: 'hair', label: 'Hair Care' },
  { id: 'body', label: 'Body & Skin' },
  { id: 'nail', label: 'Nail Care' },
  { id: 'pro', label: 'Professional Salon' },
];

export const SHOP_PRODUCTS = [
  // ---- DOPAMINE (launching soon) ----
  {
    id: 'dopamine-scalp-serum-30', brand: 'DOPAMINE', category: 'hair',
    name: 'Multicomplex Exosome Scalp Serum 30ml', price: null, oldPrice: null, badge: 'Coming Soon', comingSoon: true,
    image: `${D}/product-30ml.png`,
    desc: 'A luxury exosome-inspired scalp serum for refined daily root care. Features Plant Exosome-Inspired Complex, ALGAKTIV Densidyl, Anagain, Copper Tripeptide-1 and Niacinamide for a denser-looking hair appearance.',
  },
  {
    id: 'dopamine-scalp-serum-80', brand: 'DOPAMINE', category: 'hair',
    name: 'Root Series Scalp Serum 80ml', price: null, oldPrice: null, badge: 'Coming Soon', comingSoon: true,
    image: `${D}/product-duo.png`,
    desc: 'The extended-format DOPAMINE root care ritual. The same exosome-inspired multicomplex formula in a generous 80ml bottle for a longer clinical-luxury scalp care routine.',
  },
  // ---- MAXWELL ----
  {
    id: 'maxwell-caviar-serum', brand: 'Maxwell', category: 'hair',
    name: 'Caviar Hair Serum', price: 15.99, oldPrice: 21.99, badge: 'Best Seller',
    image: `${M}/havyar-ozlu-sac-bakim-serumu-9cfe5a.png`,
    desc: 'A luxury anti-ageing hair serum rich in caviar extract and omega fatty acids. Deeply nourishes and hydrates, reduces static and helps hair look glossy, strong and revitalised. Leave-in — no rinsing required.',
  },
  {
    id: 'maxwell-caviar-mask', brand: 'Maxwell', category: 'hair',
    name: 'Caviar Repair Hair Mask 500ml', price: 11.99, oldPrice: null, badge: 'New',
    image: `${M}/havyar-ozlu-sac-maskesi-2abd40.png`,
    desc: 'An intensive caviar-extract repair mask for dry, dull, lifeless and coloured hair. Delivers deep moisture and a premium care feel, leaving hair softer, shinier and visibly healthier.',
  },
  {
    id: 'maxwell-silver-shampoo', brand: 'Maxwell', category: 'hair',
    name: 'Silver Shampoo 500ml — Purple Toning', price: 7.99, oldPrice: null, badge: 'New',
    image: `${M}/silver-sampuan-75f9ae.jpg`,
    desc: 'A purple-pigmented toning shampoo that neutralises brassy yellow and orange tones in blonde, grey, white, platinum and highlighted hair — for a cooler, brighter, well-kept colour.',
  },
  {
    id: 'maxwell-body-milk', brand: 'Maxwell', category: 'body',
    name: 'Two-Phase Body Milk 400ml', price: 6.99, oldPrice: null, badge: 'New',
    image: `${M}/cift-fazli-vucut-sutu-63e-e5.png`,
    desc: 'A two-phase body milk that intensely hydrates while absorbing fast. Soothes skin sensitised by sun, waxing or laser treatments, leaving it soft, smooth and refreshed. Suitable for daily use.',
  },
  {
    id: 'maxwell-cuticle-remover', brand: 'Maxwell', category: 'nail',
    name: 'Professional Cuticle Remover 10ml', price: 5.99, oldPrice: 8.99, badge: 'Free Delivery',
    image: `${M}/maxwell-professional-cuticle-remover-t-5b2-f2.png`,
    desc: 'Softens cuticles around the nail for effortless manicure and pedicure care — no cutting required. Ideal for home and professional routines.',
  },
  {
    id: 'maxwell-hand-body-peeling', brand: 'Maxwell', category: 'body',
    name: 'Hand & Body Peeling 150ml', price: 5.99, oldPrice: 8.99, badge: 'Best Seller',
    image: `${M}/hand-body-peeling--5f5b-.png`,
    desc: 'Professional spa-effect body peeling that gently exfoliates against dead-skin and ingrown-hair appearance for smoother, softer-looking skin.',
  },
  {
    id: 'maxwell-keratin-argan-serum', brand: 'Maxwell', category: 'hair',
    name: 'Brazilian Keratin & Argan Leave-In Serum', price: 7.99, oldPrice: 12.99, badge: null,
    image: `${M}/brezilya-keratin-argan-yagli-sac-bakim-efc-9a.jpeg`,
    desc: 'A leave-in professional treatment serum with Brazilian keratin and argan oil. Heat-protective and anti-static, it smooths frizz and leaves coloured, treated or heat-styled hair glossy, soft and easy to shape.',
  },
  {
    id: 'maxwell-neutraliser', brand: 'Maxwell', category: 'pro',
    name: 'Professional Neutraliser — Perm Fixing Lotion 500ml', price: 8.99, oldPrice: 13.99, badge: null,
    image: `${M}/notralizator-2-c959.jpeg`,
    desc: 'Professional fixing lotion used after perming to lock the new curl form in place. Gently supports the hair fibre for balanced, defined and long-lasting waves. Salon use.',
  },
  {
    id: 'maxwell-perm-c', brand: 'Maxwell', category: 'pro',
    name: 'Professional Perm Lotion C 500ml — Coloured & Sensitive Hair', price: 9.99, oldPrice: 14.99, badge: null,
    image: `${M}/perma-ilaci-c-81c142.jpeg`,
    desc: 'Professional cold-wave perm solution developed for coloured, highlighted, sensitised and chemically treated hair. Protects the hair structure while creating natural, flexible, long-lasting curls.',
  },
  {
    id: 'maxwell-perm-f', brand: 'Maxwell', category: 'pro',
    name: 'Professional Perm Lotion F 500ml — Normal & Coloured Hair', price: 9.99, oldPrice: 14.99, badge: null,
    image: `${M}/perma-ilaci-f-8-4a9e.jpeg`,
    desc: 'Professional perm lotion for normal and coloured hair. Supports even, homogeneous wave formation for permanent, natural-looking curls. Designed for salon use.',
  },
  {
    id: 'maxwell-perm-n', brand: 'Maxwell', category: 'pro',
    name: 'Professional Strong Perm Lotion N 500ml — Thick & Resistant Hair', price: 9.99, oldPrice: 14.99, badge: null,
    image: `${M}/perma-ilaci-n-706-70.jpeg`,
    desc: 'A strong professional perm lotion developed for thick-stranded and resistant hair. Its powerful formula helps create permanent, defined and elastic curls. Salon use.',
  },
  {
    id: 'maxwell-perm-set-c', brand: 'Maxwell', category: 'pro',
    name: 'Sensitive Perm Set C — 500ml Perm + 500ml Neutraliser', price: 16.99, oldPrice: 27.99, badge: 'Set',
    image: `${M}/professional-hassas-perma-seti-zayif-v-2e-5f7.jpeg`,
    desc: 'Two-piece professional perm set for weak, fine-stranded and sensitive hair: 500ml Perm Lotion C plus 500ml Neutraliser fixing lotion. Everything a salon needs for a gentle, lasting wave.',
  },
  {
    id: 'maxwell-perm-set-f', brand: 'Maxwell', category: 'pro',
    name: 'Perm Set F — 500ml Perm + 500ml Neutraliser', price: 16.99, oldPrice: 27.99, badge: 'Set',
    image: `${M}/professional-perma-seti-500-ml-perma-i-a-2218.jpeg`,
    desc: 'Two-piece professional perm set for normal and coloured hair: 500ml Perm Lotion F plus 500ml Neutraliser fixing lotion for defined, long-lasting professional waves.',
  },
  {
    id: 'maxwell-perm-set-n', brand: 'Maxwell', category: 'pro',
    name: 'Strong Perm Set N — 500ml Perm + 500ml Neutraliser', price: 16.99, oldPrice: 27.99, badge: 'Set',
    image: `${M}/professional-guclu-perma-seti-kalin-te-bd-e16.jpeg`,
    desc: 'Two-piece professional perm set for thick-stranded and resistant hair: 500ml Strong Perm Lotion N plus 500ml Neutraliser for permanent, elastic, well-defined curls.',
  },
  {
    id: 'maxwell-keratin-bond-remover', brand: 'Maxwell', category: 'pro',
    name: 'Keratin Bond Remover Solution', price: 4.99, oldPrice: 7.99, badge: null,
    image: `${M}/keratin-kaynak-sokucu--4f81-.jpeg`,
    desc: 'Professional solution for the safe, controlled removal of keratin-bond hair extensions. Developed for precise salon application without damaging the natural hair.',
  },
  {
    id: 'maxwell-dye-remover', brand: 'Maxwell', category: 'pro',
    name: 'Colour Stain Remover 250ml', price: 5.99, oldPrice: 8.99, badge: null,
    image: `${M}/boya-silici--4d29-.png`,
    desc: 'Gently lifts hair-dye stains from the skin after colouring. Its clear formula works without leaving marks, is kind to sensitive skin, fast-acting and easy to use — ideal for salons and home colourists.',
  },
  // ---- WELLMAX (salt-free, paraben-free shampoos) ----
  {
    id: 'wellmax-keratin-shampoo', brand: 'Wellmax', category: 'hair',
    name: 'Keratin Shampoo — Salt & Paraben Free', price: 6.99, oldPrice: 9.49, badge: null,
    image: `${W}/keratin-iceren-sampuan-1ee3f2.jpeg`,
    desc: 'Gently cleanses dry, dull, damaged, coloured and treated hair. Keratin-supported care helps hair look softer, shinier and smoother — a perfect post-keratin/straightening follow-up shampoo.',
  },
  {
    id: 'wellmax-argan-shampoo', brand: 'Wellmax', category: 'hair',
    name: 'Argan Extract Nourishing Shampoo', price: 7.99, oldPrice: 9.99, badge: null,
    image: `${W}/argan-ozlu-sampuan-00c5c4.jpeg`,
    desc: 'A daily-use nourishing shampoo that cleanses gently while argan extract cares for dry, dull hair — leaving it brighter, softer and healthier looking.',
  },
  {
    id: 'wellmax-kudret-shampoo', brand: 'Wellmax', category: 'hair',
    name: 'Bitter Melon Scalp Shampoo', price: 6.99, oldPrice: 9.49, badge: null,
    image: `${W}/kudret-nari-ozlu-sampuan-ace3-c.jpeg`,
    desc: 'Salt-free, paraben-free formula that cleanses hair gently while helping the scalp feel fresher and balanced. Bitter-melon extract supports livelier, softer-looking hair.',
  },
  {
    id: 'wellmax-garlic-shampoo', brand: 'Wellmax', category: 'hair',
    name: 'Garlic Extract Strengthening Shampoo', price: 6.99, oldPrice: 9.49, badge: null,
    image: `${W}/sarimsak-ozlu-sampuan-7dcc8d.jpeg`,
    desc: 'Salt-free, paraben-free shampoo that cleanses gently while helping strengthen the roots. Garlic extract supports weak, lifeless and shedding-prone hair to look stronger and healthier.',
  },
  {
    id: 'wellmax-ivy-ginger-shampoo', brand: 'Wellmax', category: 'hair',
    name: 'Ivy & Ginger Fast-Growth Shampoo', price: 6.99, oldPrice: 9.99, badge: null,
    image: `${W}/srmasik-zencefil-ozlu-sampuan-788cb-.jpeg`,
    desc: 'Salt-free, paraben-free formula with ivy and ginger extracts to help the scalp feel more vibrant and support stronger, healthier-looking hair growth.',
  },
  {
    id: 'wellmax-goatmilk-shampoo', brand: 'Wellmax', category: 'hair',
    name: 'Goat Milk Shampoo — Dry & Dull Hair', price: 6.99, oldPrice: 9.49, badge: null,
    image: `${W}/keci-sutu-ozlu-sampuan-cb7f8f.jpeg`,
    desc: 'Salt-free, paraben-free shampoo for dry, dull and lifeless hair. Goat-milk extract care helps hair look softer, shinier, livelier and healthier.',
  },
];

export const TRUST_BADGES = [
  { icon: 'ShieldCheck', title: 'Secure Shopping', sub: 'Safe & encrypted checkout' },
  { icon: 'BadgeCheck', title: '100% Original', sub: 'Authentic ARGE brands' },
  { icon: 'Headset', title: 'Customer Service', sub: 'Here to help you' },
  { icon: 'RefreshCcw', title: 'Returns & Exchange', sub: 'Hassle-free guarantee' },
];

// Category showcase tiles
export const SHOP_SHOWCASE = [
  { id: 'hair', label: 'Hair Care', image: `${W}/argan-ozlu-sampuan-00c5c4.jpeg` },
  { id: 'hair', label: 'Serums', image: `${M}/havyar-ozlu-sac-bakim-serumu-9cfe5a.png` },
  { id: 'body', label: 'Body & Skin', image: `${M}/hand-body-peeling--5f5b-.png` },
  { id: 'pro', label: 'Professional Salon', image: `${M}/perma-ilaci-c-81c142.jpeg` },
];
